"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const valueIsArray_1 = __importDefault(require("./valueIsArray"));
const valueIsNotUndefined_1 = __importDefault(require("./valueIsNotUndefined"));
const valueIsNumber_1 = __importDefault(require("./valueIsNumber"));
const valueIsRecord_1 = __importDefault(require("./valueIsRecord"));
const valueIsString_1 = __importDefault(require("./valueIsString"));
const valueIsLottieShapeLayer = (value) => {
    if (!(0, valueIsRecord_1.default)(value)) {
        return false;
    }
    if (!(0, valueIsNumber_1.default)(value.ty)) {
        return false;
    }
    if (!(0, valueIsNumber_1.default)(value.ddd)) {
        return false;
    }
    if (!(0, valueIsNumber_1.default)(value.ind)) {
        return false;
    }
    if (!(0, valueIsNumber_1.default)(value.bm)) {
        return false;
    }
    if (!(0, valueIsNumber_1.default)(value.ao)) {
        return false;
    }
    return true;
};
const valueIsLottie = (value) => {
    if (!(0, valueIsRecord_1.default)(value)) {
        return false;
    }
    if (!(0, valueIsNumber_1.default)(value.op)) {
        return false;
    }
    if (!(0, valueIsNumber_1.default)(value.fr)) {
        return false;
    }
    if (!(0, valueIsNumber_1.default)(value.w)) {
        return false;
    }
    if (!(0, valueIsNumber_1.default)(value.ddd)) {
        return false;
    }
    if (!(0, valueIsNumber_1.default)(value.h)) {
        return false;
    }
    if (!(0, valueIsString_1.default)(value.v)) {
        return false;
    }
    if ((0, valueIsNotUndefined_1.default)(value.nm) && !(0, valueIsString_1.default)(value.nm)) {
        return false;
    }
    const { layers } = value;
    if (!(0, valueIsArray_1.default)(layers)) {
        return false;
    }
    const validLayers = layers.filter(valueIsLottieShapeLayer);
    if (validLayers.length !== layers.length) {
        return false;
    }
    return true;
};
exports.default = valueIsLottie;
